export enum Status {
  ACTIVE = "#64DD17",
  IGNITION_ON = "#3A5743",
  INACTIVE = "#a3a3a3",
  ERROR = "#FF0000",
}
